import React from "react";

export default () => (
  <div className="w-full md:w-1/2 p-6 flex flex-col flex-grow flex-shrink">
    <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
      <div className="w-full font-bold text-l text-gray-800 px-6">
        Utrustning
      </div>
      <p className="text-gray-800 text-sm px-6 mb-5">
        Register innehållandes all utrustnings/inventarie relaterat till en
        anläggning.
        <br></br>
        <br></br>
        Hanterar även all data relaterat till utrustningens underhåll.
        <br></br>
        <br></br>
        Ex:
        <ul className="text-gray-800 text-sm px-6 mb-5 list-disc">
          <li>Installationsprotokoll</li>
          <li>Service</li>
          <li>Besiktningar</li>
        </ul>
      </p>
    </div>
  </div>
);
